import Vue from 'vue'
import Vuex from 'vuex'
import registro from './registro'
import contentModule, { ContentModuleState } from './content'
import validationModule, { ValidationModuleState } from './validation'
import sessionModule, { SessionModuleState } from './session'
import dataModule, { DataModuleState } from './data'
import sharedModule, { SharedModuleState } from './shared'
import participantModule, { ParticipantModuleState } from './participante'
import posterModule, { PosterModuleState } from './poster'
import certificadosModule, { CertificadosModuleState } from './certificados'

Vue.use(Vuex)

export interface StoreState {
  content: ContentModuleState
  validation: ValidationModuleState
  session: SessionModuleState
  data: DataModuleState
  shared: SharedModuleState
  participant: ParticipantModuleState
  poster: PosterModuleState
  certificados: CertificadosModuleState
}

export const store = new Vuex.Store<StoreState>({
  modules: {
    registro,
    content: contentModule,
    validation: validationModule,
    session: sessionModule,
    data: dataModule,
    shared: sharedModule,
    participant: participantModule,
    poster: posterModule,
    certificados: certificadosModule,
  },
})

export type LocalStore = typeof store
export default store
